import React from 'react';
import TopRowConf from '../../controls/configuration/TopRowConf';
import MainRowConf from '../../controls/configuration/MainRowConf';
import WindowHeight from '../../controls/frame/WinHeight';
import WindowWidthTotal from '../../controls/frame/WinWidthTotal';
import { formatToDecimal, formatToFractional } from '../../../controls/conversions';
import { alertC } from '../../../components/dialogService';

export const getConfigurationSection = (props) => {
  const {
    SECTIONS,
    isDisabled,
    topRowConfValue, setTopRowConfValue,
    archLegHeightValue, setArchLegHeightValue,
    topRowHeightValue, setTopRowHeightValue,
    mainRowConfValue, setMainRowConfValue,
    totalWindowWidthValue, setTotalWindowWidthValue,
    windowHeightValue, setWindowHeightValue,
    setWindowWidthValue1,
    setWindowWidthValue2,
    setWindowWidthValue3,
    setWindowWidthValue4,
    setWindowWidthValue5,
    setProperTopRowSectionTitle,
    // Window types and shapes for validation
    windowTypeValue1, windowTypeValue2, windowTypeValue3, windowTypeValue4, windowTypeValue5,
    windowShapeValue1, windowShapeValue2, windowShapeValue3, windowShapeValue4, windowShapeValue5,
  } = props;

  // Helper function to check if a shape ends with "Right"
  const endsWithRight = (shape) => {
    if (!shape) return false;
    return shape.trim().endsWith(' Right');
  };

  // Helper function to check if there are any non-Rectangle shapes visible in the main row
  const hasNonRectangleShapes = () => {
    const windowTypeValues = [windowTypeValue1, windowTypeValue2, windowTypeValue3, windowTypeValue4, windowTypeValue5];
    const windowShapeValues = [windowShapeValue1, windowShapeValue2, windowShapeValue3, windowShapeValue4, windowShapeValue5];

    for (let i = 0; i < mainRowConfValue; i++) {
      // Only check if the window type is "Picture"
      if (windowTypeValues[i] === 'Picture') {
        const shape = windowShapeValues[i];
        // If shape exists and is not "Rectangle" or "None", return true
        if (shape && shape !== 'Rectangle' && shape !== 'None') {
          return true;
        }
      }
    }
    return false;
  };

  // Calculate disabled options for TopRowConf
  const getDisabledTopRowOptions = () => {
    if (hasNonRectangleShapes()) {
      // Disable all options except "None"
      return ['1', 'Grid', 'Arch', 'ArchGrid', 'ArchBar'];
    }
    return [];
  };

  return [
    // Configuration section starts ...
    { id: "TopRowConf",    component: 1 > SECTIONS ? null : ( <TopRowConf
      disabled={isDisabled} id = {"TopRowConf"}  showPics={false}
      value={topRowConfValue}
      onChange={(newValue) => {
        // If trying to change from "None" when non-Rectangle shapes exist, prevent it
        if (hasNonRectangleShapes() && newValue !== 'None') {
          // Force it back to "None"
          setProperTopRowSectionTitle('None');
          setTopRowConfValue('None');
          return false;
        }
        setProperTopRowSectionTitle(newValue);
        setTopRowConfValue(newValue);
        return true;
      }}
      disabledOptions={getDisabledTopRowOptions()}
    />), position: [1, 1], status: "active", expandableSectionId: "Configuration" },

    ['Arch', 'ArchBar', 'ArchGrid'].includes(topRowConfValue) && {
      id: "ArchLegHeight",
      component: (
        <WindowHeight
          disabled={isDisabled}
          id="ArchLegHeight"
          label="Arch Leg Height"
          value={archLegHeightValue}
          onChange={(newValue) => setArchLegHeightValue(newValue)}
        />
      ),
      position: [1, 2],
      status: "active",
      expandableSectionId: "Configuration",
    },

    !['None'].includes(topRowConfValue)  &&
    { id: "WindowHeightTopRow",    component: <WindowHeight
      disabled={isDisabled} id = {"WindowHeightTopRow"} label={"Top Row Height"}
      value={topRowHeightValue}    onChange={(newValue) => { setTopRowHeightValue(newValue); }
    }/>, position: [1, 3], status: "active", expandableSectionId: "Configuration" },

    { id: "MainRowConf",    component: 1 > SECTIONS ? null : ( <MainRowConf
      disabled={isDisabled} id = {"MainRowConf"}  showPics={false}
      value={mainRowConfValue}    onChange={(newValue) => {
        const oldValue = parseInt(mainRowConfValue);
        const newValueInt = parseInt(newValue);

        // If expanding sections, check if current last position has a Right shape
        if (newValueInt > oldValue) {
          // Create arrays to check the last position
          const windowTypeValues = [windowTypeValue1, windowTypeValue2, windowTypeValue3, windowTypeValue4, windowTypeValue5];
          const windowShapeValues = [windowShapeValue1, windowShapeValue2, windowShapeValue3, windowShapeValue4, windowShapeValue5];

          // Check if position at oldValue has a Right shape (index is oldValue-1)
          const lastPositionIndex = oldValue - 1;
          if (windowTypeValues[lastPositionIndex] === 'Picture' &&
              endsWithRight(windowShapeValues[lastPositionIndex])) {
            alertC("Cannot expand sections: Position " + oldValue + " contains a 'Right' shape. Please change it to a different shape first.");
            return false; // Don't update the value - return false to prevent internal state update
          }
        }

        setMainRowConfValue(newValue);
        return true; // Allow the update
      }
    }/>), position: [2, 1], status: "active", expandableSectionId: "Configuration" },

    { id: "WindowWidthTotal",    component: <WindowWidthTotal
      disabled={isDisabled} id = {"WindowWidthMainRow"} label={"set Total Width"}
      value={totalWindowWidthValue}         onChange={(newValue) => {
                                            let oldValue = totalWindowWidthValue;
                                            if (oldValue !== newValue){
                                              setTotalWindowWidthValue(newValue);
                                              const windowWidthSetters = [
                                                0,
                                                setWindowWidthValue1,
                                                setWindowWidthValue2,
                                                setWindowWidthValue3,
                                                setWindowWidthValue4,
                                                setWindowWidthValue5
                                              ];
                                              let unit = formatToDecimal(newValue)/mainRowConfValue;
                                              if (mainRowConfValue === "3") {unit = formatToDecimal(newValue)/4;}
                                              for (let i = 1; i<= mainRowConfValue; i++){
                                                if (windowWidthSetters[i]) {
                                                  if (mainRowConfValue === "3" && i === 2){
                                                    windowWidthSetters[i](formatToFractional(2*unit));
                                                  }
                                                  else{
                                                    windowWidthSetters[i](formatToFractional(unit)); // call the setter
                                                  }
                                                }
                                              }//for
                                            }//if (oldValue !== newValue){
                                            /* mainRowConfValue */
                                          }
    }/>, position: [2, 2], status: "active", expandableSectionId: "Configuration" },

    { id: "WindowHeight",    component: <WindowHeight
      disabled={isDisabled} id = {"WindowHeightMainRow"} label={"Main Row Height"}
      value={windowHeightValue}    onChange={(newValue) => { setWindowHeightValue(newValue); }
    }/>, position: [2, 3], status: "active", expandableSectionId: "Configuration" },
    // Configuration ends ...
  ];
};
